<template>
    <div v-if="visible" class="popup-container" :class="getPopupClass()">
        <button class="popup-close"
                @click="$emit('close')"
                :class="getCloseButtonClass()">
            ×
        </button>
        <div class="popup-content">
            <p class="popup-message">{{ message }}</p>
            <div class="popup-actions">
                <button @click="$emit('close')" class="button-light-blue">{{ $t("Popup.Close") }}</button>
                <button @click="hideAndClosePopup" class="button-blue">{{ $t("Popup.ShowAgain") }}</button>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapActions } from "vuex";

    export default {
        props: {
            visible: {
                type: Boolean,
                required: true,
            },
            message: {
                type: String,
                default: "",
            },
        },
        computed: {
            isRtlLocale() {
                return this.$i18n.locale === "he-IL";
            },
        },
        methods: {
            getPopupClass() {
                return this.isRtlLocale ? "rtl-popup" : "ltr-popup";
            },
            getCloseButtonClass() {
                return this.isRtlLocale ? "popup-close-rtl" : "popup-close-ltr";
            },

            ...mapActions("leadsModule", ["setHidePhonePopup"]),

            hideAndClosePopup() {
                this.setHidePhonePopup()
                    .then(() => {
                        this.$emit("close");
                    })
                    .catch((error) => {
                        console.error("Failed to hide popup:", error);
                    });
            },
        },
    };
</script>

<style scoped>
    .popup-container {
        position: fixed;
        bottom: 20px;
        left: 50%;
        transform: translateX(-50%);
        width: 90%;
        background: #fff;
        box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
        border-radius: 8px;
        padding: 20px;
        z-index: 1000;
        overflow-y: auto;
        text-align: center;
    }

    .popup-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align: center;
        gap: 20px;
    }

    .popup-close {
        position: absolute;
        top: 10px;
        font-size: 18px;
        font-weight: bold;
        background: none;
        border: none;
        cursor: pointer;
        color: #333;
    }

        .popup-close:hover {
            color: #000;
        }

    .popup-close-ltr {
        right: 10px;
    }

    .popup-close-rtl {
        left: 10px;
    }

    .popup-message {
        font-size: 18px;
        line-height: 1.5;
        margin: 0 auto;
    }

    .popup-actions {
        display: flex;
        justify-content: center;
        gap: 15px;
    }

    .button-blue {
        background-color: #007bff;
        color: #fff;
        border: none;
        padding: 10px 20px;
        font-size: 14px;
        border-radius: 5px;
        cursor: pointer;
        min-width: 100px;
    }

    .button-light-blue {
        background-color: #17a2b8;
        color: #fff;
        border: none;
        padding: 10px 20px;
        font-size: 14px;
        border-radius: 5px;
        cursor: pointer;
        min-width: 100px;
    }

        .button-blue:hover,
        .button-light-blue:hover {
            opacity: 0.9;
        }
</style>
